import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { Button } from '@material-ui/core';
import trI18n from '@/common/utils/trI18n';
import { tr } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';
import { PropTypes } from 'prop-types';

HeaderButton.propTypes = {
    isArchiveOrTrashView: PropTypes.any,
    isDisplayButtonCluster: PropTypes.any,
    getPanelType: PropTypes.any,
    isDisplayButtonBackToArrival: PropTypes.any,
    isDisplayButtonEditTicket: PropTypes.any,
    setDisplayPopupConfirmCancel: PropTypes.any,
    setDisplayMode: PropTypes.any,
    isEditedCurrentTicket: PropTypes.any,
    isEdited: PropTypes.any,
    isCustomerOrDelivered: PropTypes.any,
    isSelectDeliver: PropTypes.any
};

export default function HeaderButton({
    detailTicket,
    handleSubmitEditTicket,
    corporationDetail,
    isSoftDelete,
    isGeneralUserWithGuest,
    setIsShowDialogRestoreTicket,
    replyToEmailTicket,
    handleBackToArrivalTicket,
    currentTicketDeliverStatus,
    isDisableBtnSave,
    isArchiveOrTrashView,
    isDisplayButtonCluster,
    getPanelType,
    isDisplayButtonBackToArrival,
    isDisplayButtonEditTicket,
    setDisplayPopupConfirmCancel,
    setDisplayMode,
    isEdited,
    isEditedCurrentTicket,
    isCustomerOrDelivered,
    isSelectDeliver
}) {
    // Re-render when the translation dictionary loads/extends so tr() text updates.
    useTranslationSubscription();

    const renderBtnCompletedDeleteAndRestoreTicket = () => {
        if (
            isSoftDelete &&
            isGeneralUserWithGuest &&
            !Utils.isDisabledTicketExternalWhenDeskServiceOff(detailTicket, corporationDetail)
        ) {
            return (
                <>
                    <Button
                        className="btn-send btn-outline-primary btn-hg32"
                        variant="contained"
                        color="primary"
                        onClick={() => setIsShowDialogRestoreTicket(true)}
                    >
                        {trI18n('HELPDESK_RESTORE')}
                    </Button>
                </>
            );
        }
    };

    return (
        <div className="col2">
            <div className="itemAddticket edit-ticket-btn">
                <div class="wrap-btn-add">
                    {!isArchiveOrTrashView && !isCustomerOrDelivered && !replyToEmailTicket && (
                        <Button
                            className="btn-send btn-outline-primary btn-hg32"
                            variant="contained"
                            color="primary"
                            onClick={() => {
                                if (!isEdited && !isEditedCurrentTicket) {
                                    setDisplayMode(Constant.DISPLAY_MODE.VIEW);
                                } else {
                                    setDisplayPopupConfirmCancel(true);
                                }
                            }}
                        >
                            {tr('編集破棄')}
                        </Button>
                    )}
                    {isDisplayButtonCluster() && (
                        <>
                            {isDisplayButtonBackToArrival() &&
                                getPanelType() !== Constant.PANEL_TYPE.CUSTOMER_TICKET_DETAIL && (
                                    <Button
                                        className="btn-send btn-outline-primary btn-hg32 btn-back-to-arrival"
                                        variant="contained"
                                        color="primary"
                                        onClick={handleBackToArrivalTicket}
                                    >
                                        {trI18n('HELPDESK_BACK_TO_NEW_SUPPORT')}
                                    </Button>
                                )}
                            {isDisplayButtonEditTicket() && (
                                <Button
                                    className="btn-send btn-primary btn-hg32"
                                    variant="contained"
                                    color="primary"
                                    onClick={handleSubmitEditTicket()}
                                    data-cy="btn-submit-add-ticket"
                                    disabled={isDisableBtnSave}
                                >
                                    {replyToEmailTicket || isSelectDeliver
                                        ? trI18n('USER04BTN001')
                                        : trI18n('COMBTN011')}
                                </Button>
                            )}
                        </>
                    )}
                    {renderBtnCompletedDeleteAndRestoreTicket()}
                </div>
            </div>
        </div>
    );
}
